export enum OtpSubmitMethod {
  BUTTON = 'button',
  AUTO_SUBMIT = 'auto_submit',
  PASTE = 'paste',
}

export enum EntryPoint {
  SP_INITIATED = 'sp_initiated',
  IDP_INITIATED = 'idp_initiated',
}

export enum LoginUsernameSubmittedErrorReason {
  LOGIN_REFUSED = 'login_refused',
  UNKNOWN = 'unknown',
}
